<template>
  <v-app-bar dark color="primary" fixed app dense>
    <v-app-bar-nav-icon to="/nav" v-if="loggedIn">
      <v-icon color="accent">menu</v-icon>
    </v-app-bar-nav-icon>
    <v-toolbar-title class="title text-center" @click.prevent="navigateToHome">
      <img src="@/assets/logo.png" />
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items v-if="loggedIn">
      <v-menu bottom min-width="200px" rounded offset-y>
        <template v-slot:activator="{ on }">
          <v-btn icon x-large v-on="on">
            <v-avatar color="success" size="38">
              <span class="white--text text-h5">{{ userName | sortName }}</span>
            </v-avatar>
          </v-btn>
        </template>
        <v-card>
          <v-list-item-content class="justify-center">
            <div class="mx-auto text-center">
              <v-avatar color="brown">
                <span class="white--text text-h5">{{
                  userName | sortName
                }}</span>
              </v-avatar>
              <h3 class="title">{{ userName }}</h3>
              <p class="text-caption mt-1">
                {{ data.email }}
              </p>
              <v-btn color="accent" class="mb-2" to="/tutoriales">
                Ver tutoriales
              </v-btn>
              <v-divider class="my-3"></v-divider>
              <v-btn depressed rounded text color="error" @click="singOut">
                Sing-out
              </v-btn>
            </div>
          </v-list-item-content>
        </v-card>
      </v-menu>
    </v-toolbar-items>
    <div id="app-qa" v-if="appName.includes('QA')" class="text-center">
      Versión de pruebas QA
    </div>
  </v-app-bar>
</template>
<script>
import { app } from "@/config/globals";
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      appName: app.name
    };
  },
  methods: {
    ...mapActions("user", ["singOut"]),
    navigateToHome() {
      this.$router.push({ name: "dashboard" });
    }
  },
  computed: {
    ...mapState("user", ["loggedIn", "userName", "data"])
  },
  filters: {
    sortName(name) {
      const nameSort = name
        .split(" ")
        .map(n => n[0])
        .join("");
      return nameSort ? nameSort : "";
    }
  }
};
</script>
<style>
img {
  height: 36px;
  margin-top: 6px;
  width: auto;
}
.title {
  width: 100%;
}
#app-qa {
  height: 27px;
  width: 100%;
  background: rgb(194, 27, 27);
  position: absolute;
  bottom: -40px;
  left: 50%;
  z-index: -1;
  transform: translate(-50%, -50%);
}
</style>
